<template>
  <div class="sider flex-v">
    <slot>
    </slot>
    <Slogan v-if="type==2" />
    <div class="qrcode" v-if="false">
      <img src="~images/qrcode.jpg">
      <div class="qrcode-layer">
        <div class="box">
          <div class="title">
            全国 <em v-text="getStatInfo.teacherCnt"></em> 名教师 <em v-text="getStatInfo.studentCnt"></em> 名学生，正在小程序中布置/完成朗读作业
          </div>
          <ul>
            <li>
              <img src="~images/qrcode1.jpg">
            </li>
            <li class="split"></li>
            <li>
              <img src="~images/qrcode.jpg">
            </li>
          </ul>
          <p class="f">
            微信搜索【朗朗书声丨统编人教语文朗读指导】公众号和小程序
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import Slogan from 'business/Slogan';
export default {
  computed: {
    ...mapGetters([
      'getStatInfo'
    ])
  },
  components: {
    Slogan
  },
  props: {
    type: {
      type: [String, Number],
      default: 1
    },
    showLogo: {
      type: Boolean,
      default: true
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
@import '~styles/var.less';
@import '~styles/mixin.less';

</style>